export enum WooStatus {
    Publish = 'publish',
    Future = 'future',
    Draft = 'draft',
    Private = 'private',
    Pending = 'pending'
}
